import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-update-task-priority-time',
  templateUrl: './update-task-priority-time.component.html',
  styleUrls: ['./update-task-priority-time.component.css']
})
export class UpdateTaskPriorityTimeComponent implements OnInit {
  taskPriority: any = []
  singleTaskPriority: any =[]
  updateForm: any | FormGroup
  timeInHrs : any = []
  formSubmit: any = false
  isLoading: any = false


  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,private router: Router) { }


  ngOnInit(): void {
    this.getAllByTaskPriority();
    this.updateForm = this.fb.group({
      timeInHrs: ['',[Validators.required]],
    })
  }

  getAllByTaskPriority(){
    this.isLoading = true
    this.generic_service.getAllByTaskPriority().subscribe(
      (res:any)=> {
        console.log(res)
        this.taskPriority = res.response
        this.isLoading = false
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getTaskPriorityByStatus(status: any){
    this.timeInHrs = ""
    this.singleTaskPriority = []

    for(let i=0;this.taskPriority.length>i;i++){
      if(this.taskPriority[i].priorityStatus == status){
        this.singleTaskPriority = this.taskPriority[i]
        // this.updateForm.patchValue({
        //   timeInHrs: this.singleTaskPriority[i].timeInHrs
        // })
        this.timeInHrs = this.taskPriority[i].timeInHrs
      }
    }
    console.log(this.singleTaskPriority)
  }

  updateTaskPriorityTime(){
    this.formSubmit = true;
    if(this.timeInHrs == ""){
      return
    }
    let body = {
      "priorityStatus": this.singleTaskPriority.priorityStatus,
      "timeInHrs": Number(this.timeInHrs),
      "cid": Number(this.singleTaskPriority.cid)
    }
    console.log(body)
    this.generic_service.updateTaskPriorityTime(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        document.getElementById("closeModalButton1")?.click()

        this.getAllByTaskPriority();
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  keyPressNumbers(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }


}

